import { FC, useState } from "react";
//!STYLE
import { Button, Input } from "antd";
import s from "./style.module.css";

type Props = {
  totalPages: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  currentPage: number;
  social?: boolean;
};
const Pagination: FC<Props> = ({ setCurrentPage, currentPage, totalPages, social }) => {
  const [itemsPerPage, setitemsPerPage] = useState(5);
  const [pageNumberLimit, setpageNumberLimit] = useState(4);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(4);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);

  const handleClick = (event: any) => {
    setCurrentPage(Number(event.target.id));
    window.scrollTo(0, 0);
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(totalPages); i++) {
    pages.push(i);
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = data?.slice(indexOfFirstItem, indexOfLastItem);

  const renderPageNumbers = pages?.map((number: any) => {
    if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
      return (
        <li
          key={number}
          id={number}
          onClick={handleClick}
          className={currentPage == number ? `${s.active}` : ""}
        >
          {number}
        </li>
      );
    } else {
      return null;
    }
  });

  const handleNextbtn = () => {
    setCurrentPage(currentPage + 1);

    if (currentPage + 1 > maxPageNumberLimit) {
      setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
    }
  };

  const handlePrevbtn = () => {
    setCurrentPage(currentPage - 1);

    if ((currentPage - 1) % pageNumberLimit == 0) {
      setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
    }
  };

  const handlePage = (value: any) => {
    if (value > totalPages) {
      return;
    }
    setCurrentPage(value);
  };

  let pageIncrementBtn = null;
  if (pages.length > maxPageNumberLimit) {
    pageIncrementBtn = <li onClick={handleNextbtn}> &hellip; </li>;
  }

  let pageDecrementBtn = null;
  if (minPageNumberLimit >= 1) {
    pageDecrementBtn = <li onClick={handlePrevbtn}> &hellip; </li>;
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  return (
    <>
      <div style={{ height: "50px", width: isMobile ? "100%" : social ? "90%" : "61%", margin: "0px auto", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: isMobile ? "center" : "space-between", paddingLeft: isMobile ? "0px" : social ? "0px" : currentPage > 1 ? "25%" : "28%", paddingRight: isMobile ? "0px" : "10px", marginBottom: isMobile ? "70px" : "40px" }}>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
          {currentPage > 1 && totalPages > 1 && <Button className={s.newButton} onClick={handlePrevbtn} disabled={currentPage == pages[0] ? true : false} style={{ marginRight: "5px" }}>
            Précédent
          </Button>}
          {totalPages > currentPage && <Button className={s.newButton} onClick={handleNextbtn} disabled={currentPage == pages[pages.length - 1] ? true : false} style={{ marginRight: "5px" }}>
            Suivant
          </Button>}
        </div>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.75em" : "14px", fontFamily: "Poppins", fontWeight: "600", color: "#707070" }}>
          Page {/* <span className={s.currentPagebox}> */}
          {/* {currentPage} */}
          <Input
            bordered={true}
            type="text"
            style={{ width: "100px", borderRadius: "7px", marginLeft: "10px", marginRight: "10px" }}
            defaultValue={currentPage}
            onBlur={(e: any) => handlePage(e.target.value)}
            onPressEnter={(e: any) => handlePage(e.target.value)}
          />
          {/* </span> */}
          Sur <span style={{ marginLeft: "10px" }}>{totalPages}</span>
        </div>
      </div>
    </>
  );
};

export default Pagination;
